'use client';

import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type MetadataRowProps = {
  className?: string;
  label: string;
  value: string | undefined;
};

export const MetadataRow = memo(({ className, label, value }: MetadataRowProps) => {
  if (!value) return null;

  return (
    <div className={cn('flex justify-between gap-4 py-1', className)}>
      <span className="shrink-0 font-medium text-12 text-neutral-10">{label}</span>
      <span className="truncate text-right font-medium text-12 text-neutral-12">{value}</span>
    </div>
  );
});

MetadataRow.displayName = 'MetadataRow';
